import { Users, CreditCard, Key, AlertTriangle } from 'lucide-react';

const stats = [
  { name: 'Total Users', value: '1,234', icon: Users, change: '+12%', changeType: 'increase' },
  { name: 'Active Credits', value: '45,678', icon: CreditCard, change: '+8%', changeType: 'increase' },
  { name: 'Active Invites', value: '89', icon: Key, change: '-5%', changeType: 'decrease' },
  { name: 'System Alerts', value: '3', icon: AlertTriangle, change: '+2', changeType: 'neutral' },
];

export function AdminOverview() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-[--text-primary]">Dashboard Overview</h1>
        <p className="mt-2 text-sm text-[--text-secondary]">
          Monitor key metrics and system status
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-[--bg-primary] overflow-hidden shadow rounded-lg"
          >
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <stat.icon className="h-6 w-6 text-[--text-disabled]" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-[--text-secondary] truncate">
                      {stat.name}
                    </dt>
                    <dd className="flex items-baseline">
                      <div className="text-2xl font-semibold text-[--text-primary]">
                        {stat.value}
                      </div>
                      <div
                        className={`ml-2 flex items-baseline text-sm font-semibold ${
                          stat.changeType === 'increase'
                            ? 'text-success-600 dark:text-success-400'
                            : stat.changeType === 'decrease'
                            ? 'text-error-600 dark:text-error-400'
                            : 'text-[--text-secondary]'
                        }`}
                      >
                        {stat.change}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="mt-8">
        <h2 className="text-lg font-medium text-[--text-primary] mb-4">Recent Activity</h2>
        <div className="bg-[--bg-primary] shadow overflow-hidden sm:rounded-lg">
          <ul role="list" className="divide-y divide-[--border-primary]">
            {[...Array(5)].map((_, index) => (
              <li key={index} className="px-4 py-4 sm:px-6">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-medium text-[--text-primary] truncate">
                    System event {index + 1}
                  </p>
                  <div className="ml-2 flex-shrink-0 flex">
                    <p className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-success-100 dark:bg-[rgb(var(--success-900)/0.2)] text-success-800 dark:text-success-200">
                      Success
                    </p>
                  </div>
                </div>
                <div className="mt-2 sm:flex sm:justify-between">
                  <div className="sm:flex">
                    <p className="flex items-center text-sm text-[--text-secondary]">
                      Action performed by system
                    </p>
                  </div>
                  <div className="mt-2 flex items-center text-sm text-[--text-secondary] sm:mt-0">
                    <p>
                      {new Date(Date.now() - index * 3600000).toLocaleString()}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}